var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.337891,
    y: 0.915585,
    width: 15.3247,
    height: 15.3247,
    fill: "url(#pattern0_6_1465)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6_1465",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_1465",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_1465",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAExklEQVR4nO2dWYgdRRSGvzHRuIAaF9SocTfGDVEnKuICrrjjQ9QIKipRDGEwGKIiCi5gRNDxwbiAuD1MQKIYJYIPRtQYRRB9cMU9JjFxJUGNTnKkoEaGYebe23Xn3vq7+3zwP07V8J++3VWn6lSB4ziO4zhF6QGOBfqAZ4A3gaMLt+K0zQHAQuA7wEboovabd1rlMGAxsHmUQAzpkpZbc5LZAXgIGGwQiCGdnt6N0wrHAV+1EIgh7d5Sq04SlwF/FQjGl2ndOK1wVYuvqOF6oKWWncKcA/xTMBjhQz+teFdOM/YBfi4YjKAXmrbsJPFqQjA2AQendec04vyEYATd3LBVJ5kVCcF4OaZQnHHmmIRgfArs5JHoDPcWDMYnwF4ejM7xRoFgvAZM9mB0ltUtBOJPYB4wwYPReTY0mfQ9B+zvgegea0cJRFjvuB84yAPRfRYCzwIPAtcBRxT42x2BI4HTgAuAk4B9qeFiUV9MWYTh58b4VP8NrALeiuaGFbztOtB/ML0f+KjBgtXq+Kqb1aH/ITvbAjcCHxQcom4EBoBzga3a7H828FnCnOU34NGqJCDDqGYusCYxtWHD9H2ccxxaoP8wxL19jO9MUQ3GV+MhlJSwq+PDcTDCRtE78Rc3WmIw/JJmAA83GYGlalN8MEr1KpsbvwnWBa0FVgLLgPcSU/ApCquMJ1OCV9SiLhliAvoXWIBwMAYETLIMelotCxDS2E8IGGMZFfZ9TUSEWwUMMQE9jgAzEjYWVFmzcgZje+AbARNMROuAe3IG5G4BE0xAbwMXAlvnDMbUgrsDq6hV8RUlsTbfL2CIZf5V7IYIu3QoLWElUchpbYMQfQKmWCa9rjYJTN0HVQV9Hd8OUuwHbBEwxzIo7JCU43oBYyyDliPKUwLmWAadhSifC5hjXdZPih9y4lCvaHVSFfQYokwTMMcyKHw3JTlPwBzLoBMR5WoBcyyD9kaUOQLmWAbJ5KxGMl/AHMsg2RKGOwTMsQyS3bU4T8Acy6CzEaWuaZM+RJkpYI5l0FJE6RUwxzJog9qC1PACl7qm3q9ElB8FzLEMCrUtkiwVMMcyKRQOyXGLgDGWSd/GYwOlOF7AGMuoRxBjQheLYkxUNyHGkwKmWEYNxqMEZThTwBQTUH+b1cHjxsRxqmytglbG2vfs3CdghokoTJaXABfnnNFPremGB2uid8nIEgEDTExhmTvrcd51zW3ZGKcQZS3aCbwiYISJ6AYE8F8J/1dTTUKE5wWeTsssqdn7nsAfAqZYJn2sdGjAEAsEjLEM2qwyMRxJeELeFzDIuqyQ15Nles1KpX8pw808ddrdeA0loKcmM/iXKBE7F7yQy0p4pskelIyjgN8FzLMOKJxrUkrOiIdGWoW0iJJzRYXS9CuU0iPtcHk8MNJKrB+AKVSIS+O1EVZCrY9zrMrRW8KtqOviXrTKMiXedJNq0GA85uLOeKPB4bHNybEW8EDg1HiY80CbSc8v6nKtXk88Knx9wdW42xLG/5Pi3bjLC6xubok5qjCfqhWhvOGuMS6ct5hJXRZ3c4zH0RbT43Xev47RXxh4vAicQs3pAU4Aro1p/Dlx8rVrBzPTvbG/+VEz47qO4ziO4ziO4ziO4ziO4zg05j+RsVQilqfpRwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/Apple Logo.29978be9e66aa7a633c15bfb756a45b3.svg";
export { ForwardRef as ReactComponent };